import _isFunction from './_isFunction.js';
import _toString from './_toString.js';

export default function _assertPromise(name, p) {
  if (p == null || !_isFunction(p.then)) {
    throw new TypeError('`' + name + '` expected a Promise, received ' + _toString(p, []));
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_assertPromise.js
// module id = 435
// module chunks = 2 3 4 5 6 7 8 10